import React, { useEffect, useState } from "react";
import { Button, CloseButton, Form, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

export default function CreateOrUpdatePrivilegeModal({
  show,
  onHide,
  onSave,
  privilege,
}) {
  const isUpdate = Boolean(privilege);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    scope: "",
    description: "",
  });

  // pre-fill form when updating
  useEffect(() => {
    if (privilege) {
      setFormData({
        name: privilege.name || "",
        scope: privilege.scope || "",
        description: privilege.description || "",
      });
    } else {
      setFormData({ name: "", description: "" });
    }
  }, [privilege, show]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (!formData.name.trim()) {
      toast.error("Privilege name is required");
      return;
    }

    if (!formData.scope.trim()) {
      toast.error("Privilege scope is required");
      return;
    }

    setSubmitting(true);
    try {
      await onSave(formData, privilege?.id);
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
      onHide();
    }
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="bg-body-tertiarydd border-0">
        <Modal.Title style={{ fontSize: 15 }} className="ps-2 ms-1 fw-bold">
          {isUpdate ? "Update Privilege" : "Add Privilege"}
        </Modal.Title>
        <CloseButton
          className="btn btn-circle btn-sm transition-base p-0 text-xxs"
          onClick={onHide}
        />
      </Modal.Header>

      <Modal.Body className="px-4 py-0">
        <Form>
          {/* Role Name */}
          <Form.Group className="mb-3">
            <Form.Label className="text-900 text-sm">Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter privilege name"
              name="name"
              size="sm"
              value={formData.name}
              onChange={handleChange}
              required
              className="text-xs"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="text-900 text-xs">Scope</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter scope"
              name="scope"
              size="sm"
              value={formData.scope}
              onChange={handleChange}
              required
              className="text-xs"
            />
          </Form.Group>

          {/* Description */}
          <Form.Group className="mb-3">
            <Form.Label className="text-900 text-xs">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Short description for this role"
              name="description"
              size="sm"
              value={formData.description}
              onChange={handleChange}
              className="text-xs"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-0 px-4 justify-content-start">
        <Button
          variant="secondary"
          onClick={onHide}
          size="sm"
          className="text-xs"
        >
          Close
        </Button>

        {submitting ? (
          <Spinner animation="border" size="md" variant="success" />
        ) : (
          <Button
            variant="success"
            size="sm"
            className="text-xs"
            onClick={handleSubmit}
          >
            {isUpdate ? "Update" : "Save"}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
